//@flow
const PHONE_REGISTRATION = 'PHONE_REGISTRATION'
const PHONE_HAS_REGISTRATION = 'PHONE_HAS_REGISTRATION'
const ONE_TIME_PASSWORD = 'ONE_TIME_PASSWORD'
const BECOME_SELLER = 'BECOME_SELLER'
const ACTION_SELLER_SELL = 'ACTION_SELLER_SELL'
const AWB_SENT_KA = 'AWB_SENT_KA'
const UPDATE_LISTING_EXPIRY = 'UPDATE_LISTING_EXPIRY';
const UPDATE_BULK_RENEW = 'UPDATE_BULK_RENEW';
const SELLER_INPUT_AWB = 'SELLER_INPUT_AWB'
const SENT_SMS = 'SENT_SMS'
const SENT_CALL = 'SENT_CALL'

export {
  PHONE_REGISTRATION,
  ONE_TIME_PASSWORD,
  PHONE_HAS_REGISTRATION,
  BECOME_SELLER,
  ACTION_SELLER_SELL,
  AWB_SENT_KA,
  UPDATE_LISTING_EXPIRY,
  UPDATE_BULK_RENEW,
  SELLER_INPUT_AWB,
  SENT_SMS,
  SENT_CALL
}